<template>
  <div class="container">
    <h1 class="mb-4">Comisión {{ comision.id }}</h1>

    <div class="details">
      <div class="details__head">
        <ul class="nav nav-tabs" role="tablist">
          <li class="nav-item tabs-item">
            <a class="nav-link active" data-toggle="tab" role="tab" href="#details">
              <fai icon="info"/>&nbsp;Generales
            </a>
          </li>
        </ul>
      </div>
      <div class="details__body mt-4">
        <div class="tab-content">
          <!--begin: Details -->
          <div id="details" class="tab-pane fade show active" role="tabpanel" v-if="comision.id">
            <div class="row">
              <div class="col-sm-6">
                <h4 class="m--font-info">Datos Generales</h4>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-6 col-md-3">
                  <h5>Impulsor</h5>
                  <span>{{ comision.promoter }}</span>
              </div>
              <div class="col-sm-6 col-md-3">
                  <h5>Tasa</h5>
                  <span>{{ comision.interest_rate }}%</span>
              </div>
              <div class="col-sm-6 col-md-3">
                  <h5>Fecha Inicio</h5>
                  <span>{{ comision.date_init | formatDate }}</span>
              </div>
              <div class="col-sm-6 col-md-3">
                  <h5>Fecha Fin</h5>
                  <span>{{ comision.date_end | formatDate }}</span>
              </div>
            </div>
            <div class="row mt-4">
                <div class="col-sm-6 col-md-3">
                    <h5>Monto Generado</h5>
                    <span>{{ comision.amount | formatCurrency }}</span>
                </div>
                <div class="col-sm-6 col-md-3">
                    <h5>Monto Pagado</h5>
                    <span>{{ comision.payed | formatCurrency }}</span>
                </div>
                <div class="col-sm-6 col-md-3">
                    <h5>Monto por Pagar</h5>
                    <span>{{ comision.pending | formatCurrency }}</span>
                </div>
                <div class="col-sm-6 col-md-3">
                    <h5>Total Inversiones</h5>
                    <span>{{ comision.total | formatCurrency }}</span>
                </div>
            </div>
            <hr class="mt-4"/>
            <div class="row">
                <div class="col-sm col-md col-lg">
                    <h4 class="m--font-info">Anexos</h4>
                </div>
            </div>
            <div class="mt-2" v-if="attachments.length">
                <div class="row">
                  <div class="col">
                    <table class="table">
                      <thead>
                        <tr>
                          <th scope="col">#</th>
                          <th scope="col">Inversionista</th>
                          <th scope="col">Contrato</th>
                          <th scope="col">Fecha de inicio</th>
                          <th scope="col">Fecha de vencimiento</th>
                          <th scope="col">Plazo (días)</th>
                          <th scope="col">Plazo (meses)</th>
                          <th scope="col">Monto de inversión</th>
                          <th scope="col">Comisión</th>
                          <th scope="col">Ajuste</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="attachment in attachments" :key="attachment.id">
                          <th scope="row" class="text-success">{{ attachment.attachment_id }}</th>
                          <td>{{ attachment.investor_name }}</td>
                          <td>{{ attachment.contract_folio }}</td>
                          <td>{{ attachment.date_init | formatDate }}</td>
                          <td>{{ attachment.date_expire | formatDate }}</td>
                          <td>{{ attachment.duration_days }}</td>
                          <td>{{ attachment.duration_months.toFixed(2) }}</td>
                          <td>{{ attachment.amount | formatCurrency }}</td>
                          <td>{{ attachment.comision_amount | formatCurrency }}</td>
                          <td>{{ attachment.comision_adjust | formatCurrency }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="mt-2" v-if="monthly_cut_attachments.length">
                <div class="row">
                  <div class="col">
                    <table class="table">
                      <thead>
                        <tr>
                          <th scope="col">#</th>
                          <th scope="col">Inversionista</th>
                          <th scope="col">Contrato</th>
                          <th scope="col">Fecha de inicio</th>
                          <th scope="col">Fecha de vencimiento</th>
                          <th scope="col">Intereses</th>
                          <th scope="col">Comisión</th>
                          <th scope="col">Tipo</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="attachment in monthly_cut_attachments" :key="attachment.id">
                          <th scope="row" class="text-success">{{ attachment.attachment_id }}</th>
                          <td>{{ attachment.investor }}</td>
                          <td>{{ attachment.contract }}</td>
                          <td>{{ attachment.init_date | formatDate }}</td>
                          <td>{{ attachment.end_date | formatDate }}</td>
                          <td>{{ attachment.net_interest | formatCurrency }}</td>
                          <td>{{ attachment.comision_amount | formatCurrency }}</td>
                          <td>Intereses Netos</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            <hr class="mt-4"/>
            <div class="row">
                <div class="col">
                    <h4 class="m--font-info">Registro</h4>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-sm-6 col-md-6">
                    <h5>Registrado Por</h5>
                    <span>{{ comision.created_by }}</span>
                </div>
                <div class="col-sm-6 col-md-6">
                    <h5>Fecha de Registro</h5>
                    <span>{{ comision.created_at }}</span>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PromotersService from '@/services/promoters'
import SysTable from '@/components/shared/Table'

export default {
  components: { SysTable },

  data () {
    return {
      comision: {},
      attachments: [],
      monthly_cut_attachments: [],
      payments: []
    }
  },
  beforeCreate: function () {
    const id = this.$route.params.id
    PromotersService.getComision(id).then(res => {
      this.comision = res.data
    })
  },
  created: function () {
    const id = this.$route.params.id
    PromotersService.listAttachments(id).then(res => {
      this.attachments = res.data
    })
    PromotersService.listMonthlyCutAttachments(id).then(res => {
      this.monthly_cut_attachments = res.data
    })
    PromotersService.getPayments(id).then(res => {
      this.payments = res.data
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/promoters/comisions/ComisionDetail.vue